import React from 'react'
import Link from 'next/link'
import Image from 'next/image'

import styled from '@emotion/styled'
import { useTranslation } from 'next-i18next'

import { BLUR, HOST, TAIL } from 'constants/image'
import Bookmark from 'components/common/Bookmark'

const PackageCard = ({ store_id, data }) => {
  const { t } = useTranslation()
  const { product_id, file_path, translate_name, price } = data

  return (
    <Container>
      <Link href={`/food/${store_id}/product/${product_id}`}>
        <Image
          src={file_path ? `${HOST}${file_path}${TAIL}` : BLUR}
          alt=""
          width={180}
          height={180}
          style={{
            borderRadius: 10,
          }}
        />
        <Bookmark
          store_id={store_id}
          product_id={product_id}
          isKTC={true}
          absolute={true}
          styles={{
            width: 32,
            height: 32,
          }}
        />
        <p className="clamp2 title">{translate_name}</p>
        <div className="display-flex-end">
          <p className="label">{t('ktc:sale_price')}</p>
          <p style={{ fontWeight: 700, margin: '0 4px', color: '#121212' }}>
            {parseInt(price).toLocaleString('ko-kr')}
          </p>
          <p className="label" style={{ color: '#121212' }}>
            KRW
          </p>
        </div>
      </Link>
    </Container>
  )
}

export default PackageCard

const Container = styled.li`
  position: relative;

  .title {
    height: 48px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  .display-flex-end {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }

  .label {
    font-weight: 400;
    font-size: 14px;
  }
`
